export const Lock = () => (
  <svg
    width="24"
    height="27"
    viewBox="0 0 24 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M6.85714 6.75V10.125H17.1429V6.75C17.1429 3.95508 14.8393 1.6875 12 1.6875C9.16071 1.6875 6.85714 3.95508 6.85714 6.75ZM5.14286 10.125V6.75C5.14286 3.05859 8.19643 0 12 0C15.75 0 18.8571 3.05859 18.8571 6.75V10.125H19.7143C22.0714 10.125 24 12.0234 24 14.3438V22.7813C24 25.1543 22.0714 27 19.7143 27H4.28571C1.875 27 0 25.1543 0 22.7813V14.3438C0 12.0234 1.875 10.125 4.28571 10.125H5.14286ZM1.71429 14.3438V22.7813C1.71429 24.2051 2.83929 25.3125 4.28571 25.3125H19.7143C21.1071 25.3125 22.2857 24.2051 22.2857 22.7813V14.3438C22.2857 12.9727 21.1071 11.8125 19.7143 11.8125H4.28571C2.83929 11.8125 1.71429 12.9727 1.71429 14.3438Z"
      fill="#2E2D25"
    />
  </svg>
);
